import { mockRepository } from './mockRepository'
import { apiRepository } from './apiRepository'
import type { AppRepository } from './types'

export type { AppRepository } from './types'

function resolveMockMode(): boolean {
  if (import.meta.env.VITE_USE_MOCK === 'true') return true
  if (typeof window !== 'undefined') {
    return new URLSearchParams(window.location.search).get('mock') === '1'
  }
  return false
}

export const isMockMode = resolveMockMode()

export const repo: AppRepository = isMockMode ? mockRepository : apiRepository
